(function() {
  'use strict';

  angular.module('blocks.cookies', []);
})();
